import { createSelector } from '@reduxjs/toolkit';

import { StreamType } from '@/pages/table/play/elements/TableStreams/TableStreams';
import { ChatMessage } from '@/services/chat/chatServicesTypes';
import { SystemMessages } from '@/services/chat/service/systemTypes';
import { ChatState } from '@/services/chat/ChatState';

import { Selector } from '../common/types/selector';
import { ReducerState } from '../common/lib/reducerState';

export const selectChatMessages = (
  tableId: string,
  streamType: StreamType,
): Selector<(SystemMessages | ChatMessage)[]> =>
  createSelector([(state: ReducerState) => state.chats?.[tableId]], (chat: ChatState) =>
    chat?.chatMessages.filter((message) => {
      if (streamType === StreamType.CHAT) {
        return !!message.alias;
      } else {
        return !message.alias;
      }
    }),
  );
